
export type NotificationFrequency = typeof NotificationFrequency[keyof typeof NotificationFrequency];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationFrequency = {
  IMMEDIATE: 'IMMEDIATE',
  DAILY_DIGEST: 'DAILY_DIGEST',
} as const;
